function formatRequestObject(object) {
  let formattedObject = [];
  for (const property in object) {
    formattedObject.push({ dataKey: property, dataValue: object[property] });
  }
  return formattedObject;
}

export { formatRequestObject };
